import axios from '@/utilities/api/axios';

export const state = initialState();

export const actions = {
  resetProjectGroupsState: async ({ commit }) => {
    commit('resetState');
  },

  getProjectGroupById: async ({ commit }, payload) => {
    try {
      const { projectGroupId } = payload;

      const res = await axios.get(
        `/project-groups/${projectGroupId}`
      );

      commit('mutateProjectGroupById', res.data);

      return res;
    } catch (error) {
      console.error(error);
      return error.response;
    }
  },

  updateProjectGroup: async (_, payload) => {
    try {
      const { projectGroupId, ...body } = payload;

      const res = await axios.put(
        `/project-groups/${projectGroupId}`,
        body
      );

      return res;
    } catch (error) {
      console.error(error);
      return error.response;
    }
  },

  deleteProjectGroup: async (_, payload) => {
    try {
      const { projectGroupId } = payload;

      const res = await axios.delete(
        `/project-groups/${projectGroupId}`
      );

      return res;
    } catch (error) {
      console.error(error);
      return error.response;
    }
  },

  createProjectGroup: async (_, payload) => {
    try {
      const res = await axios.post(
        `/project-groups`,
        payload
      );

      return res;
    } catch (error) {
      console.error(error);
      return error.response;
    }
  },

  getNestedProjectGroups: async ({ commit }, payload) => {
    try {
      const { projectGroupId, ...params } = payload;

      const res = await axios.get(
        `/project-groups/${projectGroupId}/project-groups`,
        {
          params: { ...params }
        }
      );

      commit('mutateNestedProjectGroups', res.data);

      return res;
    } catch (error) {
      console.error(error);
      return error.response;
    }
  },

  getProjectGroupMembers: async ({ commit }, payload) => {
    try {
      const { projectGroupId, ...params } = payload;

      const res = await axios.get(
        `/project-groups/${projectGroupId}/members`,
        {
          params: { ...params }
        }
      );

      commit('mutateProjectGroupMembers', res.data);

      return res;
    } catch (error) {
      console.error(error);
      return error.response;
    }
  },

  getProjectGroupDocuments: async ({ commit }, payload) => {
    try {
      const { projectGroupId, ...params } = payload;

      const res = await axios.get(
        `/project-groups/${projectGroupId}/documents`,
        {
          params: { ...params }
        }
      );

      commit('mutateProjectGroupDocuments', res.data);

      return res;
    } catch (error) {
      console.error(error);
      return error.response;
    }
  },

  updateGroupLeader: async (_, payload) => {
    const { projectGroupId, profileId } = payload;
    try {
      const res = await axios.post(
        `/project-groups/${projectGroupId}/leader?profileId=${profileId}`
      );

      return res;
    } catch (error) {
      console.error(error);
      return error.response;
    }
  }
};

export const mutations = {
  resetState: state => {
    Object.assign(state, initialState());
  },

  mutateProjectGroupById: (state, payload) => {
    state.projectGroupById = payload;
  },

  mutateProjectGroupsForUser: (state, payload) => {
    state.projectGroupsForUser = payload;
  },

  mutateNestedProjectGroups: (state, payload) => {
    //in the case this is the first time retrieving the members
    if (!state.nestedProjectGroups.hasOwnProperty('list')) {
      state.nestedProjectGroups = payload;
      return;
    }

    const { list, ...theRest } = payload;
    const combinedList = [...state.nestedProjectGroups.list, ...list];

    state.nestedProjectGroups = { ...theRest, list: combinedList };
  },

  mutateProjectGroupMembers: (state, payload) => {
    //in the case this is the first time retrieving the members
    if (!state.projectGroupMembers.hasOwnProperty('list')) {
      state.projectGroupMembers = payload;
      return;
    }

    const { list, ...theRest } = payload;
    const combinedList = [...state.projectGroupMembers.list, ...list];
    state.projectGroupMembers = { ...theRest, list: combinedList };
  },

  mutateProjectGroupDocuments: (state, payload) => {
    //in the case this is the first time retrieving the members
    if (!state.projectGroupDocuments.hasOwnProperty('list')) {
      state.projectGroupDocuments = payload;
      return;
    }

    const { list, ...theRest } = payload;
    const combinedList = [...state.projectGroupDocuments.list, ...list];
    state.projectGroupDocuments = { ...theRest, list: combinedList };
  },

  mutateProjectGroupMemberInSelectedProjectGroup: (state, payload) => {
    const { memberOfId, memberOf } = payload;

    const indexOfMember = state.projectGroupMembers.list.findIndex(member => {
      return member.memberOf.memberOfId === memberOfId;
    });

    state.projectGroupMembers.list[indexOfMember].memberOf = memberOf;
  }
};

export const getters = {};

function initialState() {
  return {
    projectGroupById: {},
    nestedProjectGroups: [],
    projectGroupMembers: [],
    projectGroupDocuments: [],
    projectGroupsForUser: []
  };
}
